/**
 * Central brand configuration.
 *
 * Change these values to customize the look and feel for each customer project.
 * This is the ONLY file you need to edit for basic branding.
 */

export const brand = {
  // App name shown in header, sidebar, and browser tab
  appName: 'Tierfriedhof Portal',

  // Short name for sidebar header (max ~12 chars)
  shortName: 'TFP',

  // Logo: das runde Kunden-Emblem (Hund vor Grabstein), freigestellt. Das große Logo mit Wortmarke
  // steht nur auf den Rechnungen (backend/.../briefkopf/logo.png). Quelle beider: public/branding.
  logo: '/branding/emblem.png' as string | null,

  // Logo size in pixels (width x height)
  logoSize: { width: 32, height: 32 },
} as const;

/**
 * Color palette for the brand.
 *
 * To change the primary color scheme, update the 'brand' colors below.
 * These map to Tailwind's color scale (50-950).
 *
 * Popular presets (replace the whole brand object):
 *
 * Indigo (default):  { 50:'#eef2ff', 100:'#e0e7ff', 200:'#c7d2fe', 300:'#a5b4fc', 400:'#818cf8', 500:'#6366f1', 600:'#4f46e5', 700:'#4338ca', 800:'#3730a3', 900:'#312e81', 950:'#1e1b4e' }
 * Blue:              { 50:'#eff6ff', 100:'#dbeafe', 200:'#bfdbfe', 300:'#93c5fd', 400:'#60a5fa', 500:'#3b82f6', 600:'#2563eb', 700:'#1d4ed8', 800:'#1e40af', 900:'#1e3a8a', 950:'#172554' }
 * Emerald:           { 50:'#ecfdf5', 100:'#d1fae5', 200:'#a7f3d0', 300:'#6ee7b7', 400:'#34d399', 500:'#10b981', 600:'#059669', 700:'#047857', 800:'#065f46', 900:'#064e3b', 950:'#022c22' }
 * Rose:              { 50:'#fff1f2', 100:'#ffe4e6', 200:'#fecdd3', 300:'#fda4af', 400:'#fb7185', 500:'#f43f5e', 600:'#e11d48', 700:'#be123c', 800:'#9f1239', 900:'#881337', 950:'#4c0519' }
 * Amber:             { 50:'#fffbeb', 100:'#fef3c7', 200:'#fde68a', 300:'#fcd34d', 400:'#fbbf24', 500:'#f59e0b', 600:'#d97706', 700:'#b45309', 800:'#92400e', 900:'#78350f', 950:'#451a03' }
 * Teal:              { 50:'#f0fdfa', 100:'#ccfbf1', 200:'#99f6e4', 300:'#5eead4', 400:'#2dd4bf', 500:'#14b8a6', 600:'#0d9488', 700:'#0f766e', 800:'#115e59', 900:'#134e4a', 950:'#042f2e' }
 */
export const brandColors = {
  50:  '#ecfdf5',
  100: '#d1fae5',
  200: '#a7f3d0',
  300: '#6ee7b7',
  400: '#34d399',
  500: '#10b981',
  600: '#059669',
  700: '#047857',
  800: '#065f46',
  900: '#064e3b',
  950: '#022c22',
} as const;

/**
 * Sidebar color scheme.
 * Dark sidebar is the default. Change these for a light sidebar or custom colors.
 */
export const sidebarColors = {
  background:       '#0f291f',
  headerBorder:     '#1c3d30',
  brandText:        '#34d399',   // Sidebar brand name color
  linkText:         '#cbd5e1',
  linkHover:        '#1c3d30',
  linkActiveBg:     '#047857',
  linkActiveBorder: '#34d399',
  footerBorder:     '#1c3d30',
  avatarBg:         '#34d399',
  roleText:         '#94a3b8',
  menuBg:           '#1c3d30',
  menuHover:        '#27553f',
} as const;
